import {Component, Inject, Input, OnDestroy, OnInit, Optional, ViewChild} from '@angular/core';
import {AccountContextValue, CoreConstants, IContextService} from '@pershing/pershing-core';
import {FormControl} from '@angular/forms';
import {TradingService} from '../../services/common/trading-service.service';
import {Account} from '../../models/common/trading-common.model';
import {Subscription} from 'rxjs';
import {OrderActionParams} from "../../models/common";
import {ORDER_ACTIONS} from "../../utils";

@Component({
    selector: 'account-picker',
    templateUrl: './account-picker.component.html'
})
export class TradingAccountPickerComponent implements OnInit, OnDestroy {
    public accountsList: any = null;
    noAccount: boolean;
    singleAccount: boolean;
    addLongDisplayClass: boolean = false;

    @Input() platform: string;
    @Input() isTrading529Attr: string = 'false';
    @Input() isTradingAttr: string = 'false';

    isTrading529: boolean = false;
    isTrading: boolean = false;

    private newOrderSub: Subscription;
    private onAccountListSub: Subscription;
    selectedAccount: Account;
    accountControl = new FormControl('');

    @ViewChild('accountSelect') select;
    constructor(private contextService: IContextService, public tradingService: TradingService,
                @Optional() @Inject('AppSettings') appSettings: any) {

        if (appSettings) {
            this.platform = appSettings.platform;
        }
    }

    ngOnInit() {
        // to ensure the account number only comes from the dropdown and isn't carried over from a different page.
        this.contextService.clearContext();

        // the attribute that comes from the DOM is always string.
        // it returns true as long as it has some string.
        console.log(this.isTradingAttr, typeof this.isTradingAttr);
        if (this.isTradingAttr === 'true') {
            this.isTrading = true;
        }
        console.log(this.isTrading, typeof this.isTrading);

        if (this.isTrading529Attr === 'true') {
            this.isTrading529 = true;
        }

        this.accountControl.valueChanges.subscribe((change: any) => this.onAccountChange(change));

        this.onAccountListSub = this.tradingService.onAccountListSubject$.subscribe((accountsList: Account[]) => this.onAccountList(accountsList));

        this.tradingService.getAccounts(this.platform);

        this.tradingService.orderActionResult$.subscribe((orderActionParams:OrderActionParams) => this.onOrderAction(orderActionParams));

        // a new trade is submitted. enable the account drop-down if it is disabled during the edit order.
        this.newOrderSub = this.tradingService.onClearOrderEntryFormSubject$.subscribe((data: any) => this.onNewOrder(data));
        this.tradingService.selectedEligibleaccount$.subscribe((selectedAccount:Account) => this.onNewAccontSelected(selectedAccount));      
    }

    onNewAccontSelected(account: Account){
        if (account === null) {
            return;
          }
        console.log(account);        
        this.accountControl.setValue(account);   
    }

    onNewOrder(data: any) {
      if (data && this.accountControl.disabled) {
        this.accountControl.enable({ onlySelf: true, emitEvent: false });
      }
    }

    onOrderAction(orderActionParams: OrderActionParams) {
      if (orderActionParams === null) {
        return;
      }

      if (orderActionParams.action === ORDER_ACTIONS.CHANGE){
          this.accountControl.disable({ onlySelf: true, emitEvent: false });
      }
    }

    onAccountChange(selectedACcount: any) {
        if ( selectedACcount ) {
            this.setDomainContext(selectedACcount);
        }
    }

    onAccountList(accounts: Account[]) {
        if (accounts) {
            this.accountsList = this.tradingService.updateAccountsList(accounts, this.isTrading, this.isTrading529);

            if (this.accountsList.length === 1) {
                this.singleAccount = true;
                this.noAccount = false;
                this.setDomainContext(this.accountsList[0]);
            } else if (this.accountsList.length > 1) {
                this.singleAccount = false;
                this.noAccount = false;
            } else if (this.accountsList.length === 0 ) {
                this.noAccount = true;
            }
        }
    }

    setDomainContext(contextObject: any) {
        let accountContextValue: AccountContextValue = new AccountContextValue(contextObject);

        let account = contextObject as Account;

        if (account != null) {
            accountContextValue.accountNumber = account.acctNum;
            accountContextValue.accountType = account.acctType;
        }

        this.contextService.setDomainContext(CoreConstants.ACCOUNT, accountContextValue);
    }

    ngOnDestroy() {
        this.newOrderSub.unsubscribe();
        this.onAccountListSub.unsubscribe();
    }
}
